import { Field, Form, Formik } from "formik";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../shared-components/button/loader-button";
import Label from "../../../shared-components/label/label";
import { integerRegex } from "../../../constants/constants";
import { discountValidateSchema, overAllDiscountValidateSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { toHalfWidth } from "../../../helpers/validate-helper";
import FormikFormInputRegexCheckFormattedNumber from "../../../shared-components/FormikFormHandlers/FormikFormInputRegexCheckFormattedNumber";

const AddEditDiscount = (props: any) => {
  const {
    selectedItemDiscountDetails,
    modalClosed,
    submitHandler,
    paymentSummary,
  } = props;
  let initialValues = {
    DiscountType:
      selectedItemDiscountDetails.saleItem.DiscountType?.toString() || "0",
    DiscountCash: selectedItemDiscountDetails.saleItem.DiscountCash,
    DiscountPercent: selectedItemDiscountDetails.saleItem.DiscountPercent,
  };
  return (
    <>
      <Modal
        className="add-user-modal correction-modal fancy-modal"
        show={true}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {!selectedItemDiscountDetails.isOverall ? (
              <FormattedMessage id="apply_discount" />
            ) : (
              <FormattedMessage id="apply_overall_discount" />
            )}
            <button onClick={props.modalClosed} className="Crossicons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validateOnBlur={false}
          validationSchema={
            selectedItemDiscountDetails.isOverall
              ? overAllDiscountValidateSchema(paymentSummary.Subtotal)
              : discountValidateSchema(selectedItemDiscountDetails)
          }
          onSubmit={async (values) => {
            let tempValues = { ...values };
            tempValues.DiscountPercent =
              tempValues.DiscountType == 0 || tempValues.DiscountType == 2
                ? parseInt(toHalfWidth(values.DiscountPercent))
                : 0;
            tempValues.DiscountCash =
              tempValues.DiscountType == 1 || tempValues.DiscountType == 2
                ? parseInt(toHalfWidth(values.DiscountCash))
                : 0;
            tempValues.DiscountType = parseInt(values.DiscountType);
            props.submitHandler(tempValues);
          }}
        >
          {({ values }) => {
            return (
              <Form className="user-form">
                <Modal.Body>
                  <div className="d-flex gap-3">
                    <div className="mb-2">
                      <Field
                        type="radio"
                        name="DiscountType"
                        value="0"
                        id="discountPercent"
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="discountPercent"
                      >
                        <FormattedMessage id="discount_percent" />
                      </label>
                    </div>
                    <div className="mb-2">
                      <Field
                        type="radio"
                        name="DiscountType"
                        value="1"
                        id="discount_cash"
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="discount_cash"
                      >
                        <FormattedMessage id="discount_cash" />
                      </label>
                    </div>
                    <div className="mb-2">
                      <Field
                        type="radio"
                        name="DiscountType"
                        value="2"
                        id="both"
                        className="form-check-input"
                      />
                      <label className="form-check-label" htmlFor="both">
                        <FormattedMessage id="both" />
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="discount_percent"
                      />
                      <Field
                        name="DiscountPercent"
                        className="form-control"
                        type="text"
                        placeholder="discount_percent"
                        regex={integerRegex}
                        as={FormikFormInputRegexCheckFormattedNumber}
                        disabled={
                          !(
                            values.DiscountType == 0 || values.DiscountType == 2
                          )
                        }
                      />
                    </div>
                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="discount_cash"
                      />
                      <Field
                        name="DiscountCash"
                        className="form-control"
                        type="text"
                        placeholder="discount_cash"
                        regex={integerRegex}
                        as={FormikFormInputRegexCheckFormattedNumber}
                        disabled={
                          !(
                            values.DiscountType == 1 || values.DiscountType == 2
                          )
                        }
                      />
                    </div>
                  </div>
                </Modal.Body>
                {/* Footer Buttons */}
                <div className="modal-footer center-content">
                  <Button
                    variant="outline-danger"
                    type="button"
                    onClick={props.modalClosed}
                    disabled={false}
                  >
                    <i className="bi bi-x-lg me-1"></i>
                    <FormattedMessage id="close" />
                  </Button>
                  <LoaderButton
                    type="submit"
                    iconName="bi-check-lg"
                    isLoading={props.addUpdateStoreManagementLoading}
                    text="button_save"
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default AddEditDiscount;
